"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wallet = void 0;
var __1 = require("..");
var Wallet = /** @class */function () {
  function Wallet(currency_id) {
    var _a;
    this._balancesChargePriority = [__1.AccountBalanceTypeEnum.plan_grants, __1.AccountBalanceTypeEnum.reward, __1.AccountBalanceTypeEnum.gifts, __1.AccountBalanceTypeEnum.coupons, __1.AccountBalanceTypeEnum.paid];
    this.balances = (_a = {}, _a[__1.AccountBalanceTypeEnum.paid] = 0, _a[__1.AccountBalanceTypeEnum.hold] = 0, _a[__1.AccountBalanceTypeEnum.onclass_fee] = 0, _a[__1.AccountBalanceTypeEnum.fine] = 0, _a[__1.AccountBalanceTypeEnum.transaction_fee] = 0, _a[__1.AccountBalanceTypeEnum.coupons] = 0, _a[__1.AccountBalanceTypeEnum.gifts] = 0, _a[__1.AccountBalanceTypeEnum.plan_grants] = 0, _a[__1.AccountBalanceTypeEnum.reward] = 0, _a[__1.AccountBalanceTypeEnum.meetings] = 0, _a);
    this._currency_id = currency_id;
  }
  Object.defineProperty(Wallet, "CLEANABLE_BALANCES", {
    get: function () {
      return [__1.AccountBalanceTypeEnum.paid, __1.AccountBalanceTypeEnum.gifts, __1.AccountBalanceTypeEnum.plan_grants];
    },
    enumerable: false,
    configurable: true
  });
  Wallet.prototype.initBalances = function (balances) {
    this.balances = __assign(__assign({}, this.balances), balances);
  };
  /**
   * @deprecated
   * @see initBalances
   */
  Wallet.prototype.setBalances = function (balances) {
    this.balances = __assign(__assign({}, this.balances), balances);
  };
  Wallet.prototype.getTotalBalance = function () {
    var _this = this;
    return Object.keys(__1.AccountBalanceTypeEnum).filter(function (k) {
      return typeof __1.AccountBalanceTypeEnum[k] !== 'number';
    }).reduce(function (sum, key) {
      return sum + _this.balances[key];
    }, 0);
  };
  Wallet.prototype.getAvailableBalance = function () {
    var _this = this;
    return __1.ACountableBalances.reduce(function (sum, balanceType) {
      return sum + _this.balances[balanceType];
    }, 0);
  };
  return Wallet;
}();
exports.Wallet = Wallet;
